import React from 'react'
import { AreaChart, Area, ResponsiveContainer, YAxis } from 'recharts'

const ILCampaignDonationChart = (props) => {
  var partyStrokeColor = (props.party == 'Republican') ? 'rgba(170, 0, 0, 0.7)' : 'rgba(0, 51, 102, 0.7)'
  var partyFillColor = (props.party == 'Republican') ? 'rgba(170, 0, 0, 0.5)' : 'rgba(0, 51, 102, 0.5)'
  return (<ResponsiveContainer width="100%" height={28}>
    <AreaChart data={props.data}>
      <Area type="monotone" dataKey="amount" isAnimationActive={false} stroke={partyStrokeColor} fill={partyFillColor} />
      <YAxis domain={[0, props.max]} hide={true} scale={props.scale} />
    </AreaChart>
  </ResponsiveContainer>)
}

export default ILCampaignDonationChart



// WEBPACK FOOTER //
// ./src/components/ILCampaignDonationChart/index.js